import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ListPageService } from './list-page.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-list-page',
  templateUrl: './list-page.component.html',
  styleUrls: ['./list-page.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPageComponent implements OnInit {
  searchText: string = '';
  filteredOrders = [];
  filterForm = new FormGroup({
    date: new FormControl(),
  });
  orders: any;
  loading: boolean = false;
 

  constructor(
    private router: Router,
    private listPageService: ListPageService,
    private toastr: ToastrService, 
  ) {}

  ngOnInit(): void {
    this.checkLogin();
    this.getOrders();
    localStorage.removeItem('pageHeaders');
    const vendorName = localStorage.getItem('vendorName') || '';
    
    (document.getElementsByClassName('toolbar-hamburger-menu')[0] as HTMLElement).innerText = 'menu';          
    (document.getElementsByClassName('toolbar-back-button')[0] as HTMLElement).innerText = '';
    (document.getElementsByClassName('toolbar-title')[0] as HTMLElement).innerText = 'Purchase Orders';
    (document.getElementsByClassName('toolbar-sub-title')[0] as HTMLInputElement).innerHTML = '';
    (document.getElementsByClassName('vendor-name')[0] as HTMLElement).innerText = vendorName;
    
    this.filterForm.get('date')?.valueChanges.subscribe((selectedDate) => {
      this.filterOrdersByDate(selectedDate);
    });    
  }

  checkLogin(){
    let spareLoginToken = localStorage.getItem('vendorKey');
    if(!spareLoginToken){
      this.router.navigate(['login']);
    }
  }

  getStatusName(statusCode: number): string {
    // console.log('getStatusName called with:', statusCode);
    const statusMap = {
      0: 'CANCELLED',
      1: 'CREATED',
      2: 'CONFIRMED',
      3: 'READY TO PICK',
      4: 'DISPATCHED',
    };
    return statusMap[statusCode] || 'UNKNOWN';
  }
  
 
  getOrders() {
    this.loading = true;
    const vendorKey = localStorage.getItem('vendorKey');
    this.listPageService.getOrderList(vendorKey,this.pageIndex , this.pageSize).subscribe(
      (response): any => {
        let res = JSON.parse(JSON.stringify(response));
        if (res.code === 200) {  
          this.loading = false; 
          this.orders = res.data.data;
          console.log("res",res)
          this.length = res.data.totalItems;
        this.totalPages = res.data.totalPage;
        this.pageIndex = res.data.currentPage;
        // console.log("this.totalPages",this.totalPages);
        // console.log("this.pageIndex",this.pageIndex);
          this.filteredOrders = this.orders.sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime());  

          // this.orders = res.data.data || [];
          // this.filteredOrders = [...this.orders]; 
          // console.log("this.filteredOrders---",this.filteredOrders);
          // const sortedData = this.filteredOrders.sort((a: any, b: any) => {
          //   return new Date(b.created).getTime() - new Date(a.created).getTime();
          // });

         
          // console.log("list-",sortedData);
          // console.log("orders-",this.filteredOrders[0].orderKey);
          // localStorage.setItem('orderKey',this.filteredOrders[0].orderKey);
        }else{
          this.loading = false;
        }
      }
    );
  }
  
  

  // clearSearch() {
  //   this.searchText = '';
  //   // this.getOrders();
  // }


  filterOrdersBySearch() {
    if (!this.searchText) {
      this.getOrders();
      return;
    }
  
    const searchTextLower = this.searchText.toLowerCase();
  
    // Mapping supplier status codes to status names
    const statusMap = {
      0: 'CANCELLED',
      1: 'CREATED',
      2: 'CONFIRMED',
      3: 'READY TO PICK',
      4: 'DISPATCHED',
    };
  
    this.filteredOrders = this.orders.filter((order) => {
      const statusName = statusMap[order.supplierStatus] || 'UNKNOWN'; // Get status name for the code
      return (
        (order.itemNames?.join(', ') || '').toLowerCase().includes(searchTextLower) ||
        (order.id?.toString() || '').toLowerCase().includes(searchTextLower) ||
        (order.make?.toString() || '').toLowerCase().includes(searchTextLower) ||
        (order.model?.toString() || '').toLowerCase().includes(searchTextLower) ||
        (order.registraionNumber?.toString() || '').toLowerCase().includes(searchTextLower) ||
        statusName.toLowerCase().includes(searchTextLower) // Check against the hardcoded status name
      );
    });
  }
  
  

  filterOrdersByDate(selectedDate: Date | null) {
    if (!this.orders || this.orders.length === 0) {
      // If orders are not yet initialized, return early
      return;
    }
    if (!selectedDate) {
      // Clear the date from the search bar
      this.searchText = '';
      this.filteredOrders = [...this.orders]; // Reset to the full list
      return;
    }
  
    const selectedDateString = selectedDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  
    // Update the search bar with the selected date
    this.searchText = selectedDateString;
  
    // Filter the orders for the selected date
    const matchingOrders = this.orders.filter((order) => {
      const orderDate = new Date(order.created).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
      return orderDate === selectedDateString;
    });
  
    if (matchingOrders.length > 0) {
      this.filteredOrders = matchingOrders;
    } else {
      this.filteredOrders = [];
    }
  }
  
  
  clearSearch() {
    this.searchText = '';
    this.filterForm.get('date')?.setValue(null); 
    this.filteredOrders = [...this.orders]; 
  }
  handleViewDetails(orderKey: string ): void {
    if (orderKey!=null) {
      this.viewDetails(orderKey); 
    } else {
      this.toastr.warning('Invalid Order');
    }
  }
  
  
  viewDetails(key) {

    this.router.navigate(['order-details/'+key]);
    
  }
  goToMyRequest() {
    this.clearSearch();
    // this.router.navigate(['order-list']); 
  }

  pageIndex : number = 0;
  pageSize : number = 400;
  totalPages : number = 0;
  length : number = 0;
  handlePageEvent(event: any) {
    
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.getOrders();
  }
  
}
